import { IndividualReport } from 'chaika-frontend-types/frontend-cms';
import { useDownloadFile } from '@utils/hooks/useDownloadFile';
import { individualReportsService } from '../service/IndividualReportService';

interface UseIndividualReportRender {
    render(individualReport: IndividualReport, params?: any): Promise<void>;
}

export function useIndividualReportRender(): UseIndividualReportRender {
    const { downloadFileFromBlobOrString } = useDownloadFile();

    async function render(individualReport: IndividualReport, params: object): Promise<void> {
        const file = await individualReportsService.renderTemplate(individualReport, params);
        downloadFileFromBlobOrString(file, individualReport.title ?? 'Report', 'docx');
    }

    return {
        render,
    };
}
